"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contextSourceOption = void 0;
// introduce number parser v2

var contextSourceOption = {
  "default": 'Default',
  account: 'Account'
};
exports.contextSourceOption = contextSourceOption;
//# sourceMappingURL=NumberValidate.interface.js.map
